
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getValetCustomerList, ValetCustomerListDto } from '@/api/commonConfig'

Component.registerHooks(['beforeRouteLeave'])

@Component({
  name: 'ChooseCustomer'
})
export default class ChooseCustomer extends Vue {
  @Getter companyId!: string

  value = ''
  phone = '1564574555'

  customerList: ValetCustomerListDto[] = []
  params = {
    companyId: '',
    pageIndex: 1,
    pageSize: 20,
    isPage: true,
    query: '',
    isAllowBuy: 1
  }
  refreshing = false
  loading = false
  finished = false
  chooseData: ValetCustomerListDto = {}
  customerIdFlag = ''

  created () {
    this.params.companyId = this.companyId
    this.customerIdFlag = this.$route.query.customerId as string
    this.chooseData.companyId = this.$route.query.customerId as string
    this.chooseData.customerName = this.$route.query.customerName as string
    this.chooseData.customerLever = this.$route.query.customerLever as string
    this.chooseData.customerLeverName = this.$route.query
        .customerLeverName as string
    this.getList()
  }

  handleBack () {
    this.$router.back()
  }

  beforeRouteLeave (to, from, next) {
    if (!this.$checkIsEmpty(this.customerIdFlag)&&(this.customerIdFlag !== this.chooseData.companyId)) {
      this.$confirmDialog.show({
        okText: '确认',
        cancelText: '取消',
        tips: '修改客户后，将清除已选择的商品数据，确定修改?',
        onOk: () => {
          to.query.fromPath = '1'
          to.query.customerId = this.chooseData.companyId
          to.query.customerName = this.chooseData.customerName
          to.query.customerLever = this.chooseData.customerLever
          to.query.customerLeverName = this.chooseData.customerLeverName
          next()
        },
        onCancel: () => {
          to.query.fromPath = '1'
          to.query.customerId = this.$route.query.customerId
          to.query.customerName = this.$route.query.customerName
          to.query.customerLever = this.$route.query.customerLever
          to.query.customerLeverName = this.$route.query.customerLeverName
          next()
        }
      })
    } else {
      to.query.fromPath = '1'
      to.query.customerId = this.chooseData.companyId
      to.query.customerName = this.chooseData.customerName
      to.query.customerLever = this.chooseData.customerLever
      to.query.customerLeverName = this.chooseData.customerLeverName
      next()
    }
  }

  getList () {
    getValetCustomerList(this.params)
        .then((res) => {
          this.refreshing = false
          this.customerList = res.data.records || []
          if (this.customerList.length >= res.data.totalRecords) {
            this.finished = true
          } else {
            this.finished = false
          }
        })
        .catch(() => {
          this.refreshing = false
        })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  /**
   * 上拉加载更多
   * */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    getValetCustomerList(this.params)
        .then((res) => {
          this.loading = false
          this.customerList = this.customerList.concat(res.data.records)
          if (this.customerList.length >= res.data.totalRecords) {
            this.finished = true
          }
        })
        .catch(() => {
          this.loading = false
        })
  }

  searchList () {
    this.params.pageIndex = 1
    this.getList()
  }

  chooseCustomer (data: ValetCustomerListDto) {
    this.chooseData = data
    // 重新修改为使用this.$router.back();
    this.$router.back()
  }
}
